exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  /* Margin bottom by footer height */\n  margin-bottom: 60px; }\n\n.footer {\n  position: absolute;\n  bottom: 30;\n  width: 100%;\n  /* Set the fixed height of the footer here */\n  height: 60px;\n  background-color: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/footer/footer.component.scss
// module id = 27
// module chunks = 0 1